// 치과 「보낸 소식」 보드 데이터 훅 (2026-10-07 — ClinicNoticeBoard.js 의 상태를 공용으로 추출. 환자 자동관리 통합 화면 ①·②와 구 탭 컴포넌트가 함께 쓴다)
// 계약 docs/계약_치과_보낸소식_웹_2026-10-06.md §2 — range 3개(today·week·last7, 독립 오류). 10-15부터 진입 시 묶음 1회 호출. 문구는 서버 texts·labels 그대로.
import { useCallback, useEffect, useState } from 'react';
import { listClinicNoticeBoard, listClinicNoticeBoards, describeNoticesError, BOARD_RANGES } from '../services/clinicNoticesApi';

export function useNoticeBoard() {
    const [state, setState] = useState(() => Object.fromEntries(BOARD_RANGES.map(r => [r, { loading: true, error: '', data: null }])));

    const loadOne = useCallback(async (range) => {
        setState(s => ({ ...s, [range]: { ...s[range], loading: true, error: '' } }));
        try {
            const d = await listClinicNoticeBoard(range);
            setState(s => ({ ...s, [range]: { loading: false, error: '', data: d } }));
        } catch (e) {
            setState(s => ({ ...s, [range]: { ...s[range], loading: false, error: describeNoticesError(e) } }));
        }
    }, []);
    // 10-15 로딩 개선: 첫 진입·새로고침은 한 번 호출(서버 인스턴스 1개만 깨움). 서버가 옛 판이거나 묶음 호출이 실패하면 range 별 3번으로 되돌아간다
    const loadAll = useCallback(async () => {
        setState(s => Object.fromEntries(BOARD_RANGES.map(r => [r, { ...s[r], loading: true, error: '' }])));
        let boards = null;
        try { boards = await listClinicNoticeBoards(BOARD_RANGES); }
        catch (e) { console.error('[보낸소식] 묶음 조회 실패 — range 별로 다시 부름:', e?.code || e?.message); }
        if (!boards) { BOARD_RANGES.forEach(r => { loadOne(r); }); return; }
        setState(Object.fromEntries(BOARD_RANGES.map(r => {
            const b = boards[r];
            return [r, b instanceof Error ? { loading: false, error: describeNoticesError(b), data: null } : { loading: false, error: '', data: b }];
        })));
    }, [loadOne]);

    useEffect(() => { loadAll(); }, [loadAll]);

    return { state, loadOne, loadAll };
}

export default useNoticeBoard;
